// NOTE: Update the SVG sanitizer filter in `functions.php#vcp_st_add_svg_icon_sprite`
//       if an SVG is rendered incomplete.

/* eslint-disable import/no-unresolved */
import '../../images/magnifying-glass.svg?sprite';
import '../../images/hamburger.svg?sprite';
import '../../images/chevron-up.svg?sprite';
import '../../images/chevron-right.svg?sprite';
import '../../images/chevron-down.svg?sprite';
import '../../images/chevron-left.svg?sprite';
import '../../images/external.svg?sprite';
